import { Link } from 'react-router';
import { Button } from '../components/Button.js';
import { Header } from '../components/Header.js';
import { Layout } from '../components/Layout.js';
import { LoadingScreen } from '../components/LoadingScreen.js';
import { Notice } from '../components/Notice.js';
import { es } from '../i18n/es.js';
import { InvitationsList } from './admin/InvitationsList.js';
import { InviteForm } from './admin/InviteForm.js';
import { MembersList } from './admin/MembersList.js';
import { useAdminData } from './admin/useAdminData.js';

export function AdminPage() {
  const { data, error, reload } = useAdminData();
  const t = es.adminPage;

  if (!data && !error) return <LoadingScreen />;

  return (
    <Layout width="wide">
      <Header
        title={t.title}
        subtitle={t.subtitle}
        actions={
          <Link
            to="/"
            className="inline-flex min-h-11 items-center rounded-md px-3 text-sm font-medium text-neutral-700 hover:bg-neutral-100 dark:text-neutral-300 dark:hover:bg-neutral-800"
          >
            {t.backHome}
          </Link>
        }
      />

      <div className="mt-6 flex flex-col gap-10">
        <InviteForm onInvited={reload} />

        {error && !data ? (
          <Notice tone="error">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <span>{error}</span>
              <Button variant="secondary" onClick={() => void reload()}>
                {es.retry}
              </Button>
            </div>
          </Notice>
        ) : null}

        {data ? (
          <>
            <InvitationsList invitations={data.invitations} onChanged={reload} />
            <MembersList members={data.members} onChanged={reload} />
          </>
        ) : null}
      </div>
    </Layout>
  );
}
